import { render } from "./AnswerEvaluationView.vue?vue&type=template&id=36f8e3c4"
import script from "./AnswerEvaluationView.vue?vue&type=script&lang=js"
export * from "./AnswerEvaluationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__